import { QueryClient } from 'react-query';

const appQueryClient = new QueryClient({
  defaultOptions:
    {
      queries: {
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: false,
        structuralSharing: false,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
      },
    },
});

export default appQueryClient;
